<template>
  <div v-if="billing.card_data" class="card-details">
    <img
      v-if="billing.card_data.brand === 'Visa'"
      class="card-details__icon"
      src="@/assets.app/images/card-details-visa.svg"
      alt=""
    />
    <img
      v-else
      class="card-details__icon"
      src="@/assets.app/images/card-details.svg"
      alt=""
    />
    <div class="card-details__item card-details__item--number">
      <div class="payment-card__unit">
        <i class="payment-card__unit-dot"></i>
        <i class="payment-card__unit-dot"></i>
        <i class="payment-card__unit-dot"></i>
        <i class="payment-card__unit-dot"></i>
      </div>
      <div class="payment-card__unit">
        <i class="payment-card__unit-dot"></i>
        <i class="payment-card__unit-dot"></i>
        <i class="payment-card__unit-dot"></i>
        <i class="payment-card__unit-dot"></i>
      </div>
      <div class="payment-card__unit">
        <i class="payment-card__unit-dot"></i>
        <i class="payment-card__unit-dot"></i>
        <i class="payment-card__unit-dot"></i>
        <i class="payment-card__unit-dot"></i>
      </div>
      <div class="payment-card__unit">
        {{ billing.card_data.last4 }}
      </div>
    </div>
    <div class="card-details__item card-details__item--expiration">
      {{ billing.card_data.exp_month }}/{{ billing.card_data.exp_year }}
    </div>
    <a
      class="card-details__item card-details__item--edit"
      @click="$emit('change')"
    >
      edit
    </a>
  </div>
</template>

<script setup lang="ts">
import { BillingView } from '@/models/billing'

defineProps<{
  billing: BillingView
}>()

defineEmits<{
  change: []
}>()
</script>
